/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
.controller('EmbedBlockController', ['$location','$sce','$scope','$timeout','$window','BulbAssetLibraryOneDriveService','CONFIG','CONTENT_EDITOR', EmbedBlockController]);

function EmbedBlockController($location, $sce, $scope, $timeout, $window, BulbAssetLibraryOneDriveService, CONFIG, CONTENT_EDITOR) {

  var that = this;

  this.isCustomWidgetEmbed = function() {
    return $scope.contentBlockCtrl.contentBlock.html.indexOf(CONFIG.hosted4hGradingWidgetUrl) > -1;
  };


  // Watch changes within the url, update it if necessary
  var deregisterWatchUrl = $scope.$watch( function() {
    return $location.url();
  }, function(value) {
    that.pageURL = value;
    // Listening for the post so we know when to send our data
    $window.parent.addEventListener('message', receiveAndSend4Hdata, false);
  });

  /**
   * Function that handles the data that is being sent to the custom 4h widget.
   * @param event The 'message' event that gets fired from the 'postMessage' function call.
   */
  function receiveAndSend4Hdata(event) {
    if (event.origin !== CONFIG.hosted4hGradingWidgetUrl) {
      return;
    }
    if (event.data.loaded === true) {
      var iFrame = jQuery('.bulb-iframe')[0];
      iFrame.contentWindow.postMessage(that.pageURL, CONFIG.hosted4hGradingWidgetUrl);
      $window.removeEventListener('message', receiveAndSend4Hdata, false);
      deregisterWatchUrl();
    }

  }

  this.updateBlockSize = function() {
    var width = $scope.contentBlockCtrl.contentBlock.width;
    var maxSize = CONFIG.page.content.max.width;
    var height = $scope.contentBlockCtrl.contentBlock.height;
    var contentSize = jQuery('.bulb-page-content').width();
    var scale = contentSize / CONFIG.page.content.max.width;

    // Prevent width from becoming less than minWidth or greater than maxWidth, and update height and width values
    // in controller.
    that.width = Math.max($scope.contentBlockCtrl.contentBlock.minWidth,
        Math.min(width, $scope.contentBlockCtrl.contentBlock.maxWidth)) * scale;
    that.height = height * scale;

    // Determines if the width of the embed is above the threshold we allow for content to go to the right or
    // left of the image on the editor.
    $scope.contentBlockCtrl.isFullWidth = (width > (maxSize * CONTENT_EDITOR.FULL_BLOCK_WIDTH_PERCENTAGE));
  };

    $scope.$watchCollection('contentBlockCtrl.contentBlock', function() {
      that.updateBlockSize();
    });


  /**
   * Wait for page load before scanning and processing iframe.
   */
  $timeout(function () {
    loadIframeWithPDFEmbed();
    loadOneDriveFileEmbed();
  });

  /**
   * Calling this method make sure the all onedrive embed content are loaded correctly.
   */
  function loadOneDriveFileEmbed() {
    var contentBlock = $scope.contentBlockCtrl.contentBlock;
    var originalUrl = decodeURIComponent(contentBlock.originalUrl);
    if(contentBlock.blockType === 'EMBED' && originalUrl.indexOf('api.onedrive.com') !== -1) {
      // Extract the shareId from originaUrl.
      var shareId = (originalUrl.split('shares/')[1]).split('/root')[0];
      var contentBlockElement = document.getElementById($scope.contentBlockCtrl.contentBlock.id);
      angular.forEach(contentBlockElement.getElementsByClassName('embed-overlay'), function (embedBlock) {
        var iFrame = embedBlock.getElementsByTagName('iframe');
        BulbAssetLibraryOneDriveService
          .updateOneDriveItemUrl(iFrame[0], shareId, $scope.contentBlockCtrl.page.unit.id,
            $scope.contentBlockCtrl.contentBlock.id, embedBlock.children[0].innerHTML);
      });
    }
  }

  /**
   * Calling this method make sure that all the iframe with pdf embed are loaded.
   */
  function loadIframeWithPDFEmbed() {
    var allIframeWithPDFEmbedLoaded = true;
    // Get all the iFrames.
    var iFrames = document.getElementsByTagName('iframe');
    angular.forEach(iFrames, function (iFrame) {
      try {
        // Only checking if it is a google viewer.
        if (iFrame &&
          iFrame.src.indexOf('https://docs.google.com/viewer') !== -1 && iFrame.contentWindow.document) {
          // iFrame.contentWindow.document throw cross origin exception if iFrame content is loaded successfully.
          // if exception is not throw, then the iFrame content is not loaded.
          // In this case set the flag to false so that we can retry loading.
          allIframeWithPDFEmbedLoaded = false;
          iFrame.src = $sce.trustAsResourceUrl(iFrame.src);
        }
      } catch (e) {
        // Do nothing because Iframe content is Already loaded
      }
    });
    // try again after 3 seconds if content of any pdf embed iframe is not loaded.
    if (!allIframeWithPDFEmbedLoaded) {
      $timeout(loadIframeWithPDFEmbed, 3000);
    }
  }

}


